/** Refresh persisted basket dates in one read. Existing event and price identities stay attached. */
export async function refreshCourseSchedules(courses: any[], fetcher: typeof fetch = fetch) {
 const ids = [...new Set(courses.map(course => course.selectedEvent?.id).filter(Boolean))];
 if (!ids.length) return courses;
 let events: any[] = [];
 try {
  const response = await fetcher("/api/course-schedules/", {method: "POST", headers: {"Content-Type": "application/json"}, body: JSON.stringify({ids})});
  const data = await response.json();
  if (!response.ok || !Array.isArray(data.events)) throw new Error("Unavailable schedules");
  events = data.events;
 } catch { /* Keep the selected identities visible, with an explicit unavailable result. */ }
 const byId = new Map(events.map(event => [event.id, event]));
 return courses.map(course => {
  if (!course.selectedEvent?.id) return course;
  const current = byId.get(course.selectedEvent.id);
  const selectedEvent = current ? {...course.selectedEvent, ...current} : {
   ...course.selectedEvent, courseSchedule: {ok: false, eventId: course.selectedEvent.id, error: {code: "FETCH_FAILED", message: "Course dates could not be verified. Please refresh or reselect your dates.", issues: []}},
  };
  return {...course, selectedEvent};
 });
}

/** A late date refresh must preserve concurrent kit/package choices in the cart. */
export function mergeVerifiedCourseSchedules(current: any[], refreshed: any[]) {
 const byId = new Map(refreshed.filter(course => course.selectedEvent?.id).map(course => [course.selectedEvent.id, course.selectedEvent]));
 return current.map(course => {
  const selectedEvent = byId.get(course.selectedEvent?.id);
  return selectedEvent ? {...course, selectedEvent:{...course.selectedEvent,...selectedEvent}} : course;
 });
}
